import Path from "../../services/paths";
import ForecastDetailAction from "../actions/forecastDetailAction";
import utils from "../common/utils";
import axios from "axios";
import CustomToast from '../../util-functions/customToast.jsx'


class ForcastDetailMiddleware {
    static getForecastDetail(
        selectedCategory,
        selectedBrand,
        selectedSku,
        selectedRegion,
        selectedYear,
        weekFrom,
        weekTo,
        seletcWeek
    ) {
        let url = `${Path.GET_FORCAST_DETAIL}?`;

        if (Array.isArray(selectedCategory)) {
            selectedCategory.forEach(element => {
                url += `category=${element}&`;
            });
        }

        if (Array.isArray(selectedBrand)) {
            selectedBrand.forEach(element => {
                url += `brand=${element}&`;
            });
        }
        if (Array.isArray(selectedSku)) {
            selectedSku.forEach(element => {
                url += `master_sku=${element}&`;
            });
        }
        if (selectedYear) {
            url += `year=${selectedYear}&`;          
        }
        if (weekFrom) {
          url += `week_from=${weekFrom}&`;
        }
        if (weekTo) {
            url += `week_to=${weekTo}&`;
          }
        if (Array.isArray(selectedRegion)) {
            selectedRegion.forEach(element => {
                url += `region=${element}&`;
            });
        }
        url += `is_weekly=${seletcWeek}&`

        url = url.slice(0, -1);

        return dispatch => {
            dispatch(ForecastDetailAction.forecastDetailRequest());
            utils
                .get_token()
                .then(token => {
                    axios({
                        method: "GET",
                        url: url,
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => {
                            if (res.error) {
                            } else {
                                dispatch(
                                    ForecastDetailAction.forecastDetailSuccessul(res)
                                );
                            }
                        })
                        .catch(error => {
                            CustomToast('error', 'Data Fetching Failed!')
                            dispatch(ForecastDetailAction.forecastDetailFailed(error));
                        });
                })
                .catch(error => {
                    dispatch(ForecastDetailAction.forecastDetailFailed(error));
                });
        };
    }
}

export default ForcastDetailMiddleware;
